<template>
  <div class="right-panel-buttons">
    <div id="rpb-cancel-btn" class="cancel-btn" @click="cancel">
      Cancel
    </div>
    <div id="rpb-save-btn" class="save-btn" @click="save">
      {{ getSaveLabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightPanelButtons',
  props: [
    'save',
    'saveLabel',
    'cancel'
  ],
  computed: {
    getSaveLabel () {
      return (this.$props.saveLabel !== undefined) ? this.$props.saveLabel : 'SAVE';
    }
  }
};
</script>

<style>
.save-btn {
  cursor: pointer;
  background-color: var(--nelson-green);
  color: white;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 900;
  letter-spacing: 0.05em;
}
</style>

<style scoped>
.cancel-btn {
  cursor: pointer;
  color: black;
  height: 35px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
  font-weight: 500;
}
.cancel-btn:hover {
  background-color: #E7E7E7;
}
.right-panel-buttons {
  margin-top: auto;
  padding-right: 20px;
  width: 100%;
  height: 70px;
  position: sticky;
  bottom: 0px;
  display: flex;
  background-color: whitesmoke;
  align-items: center;
  justify-content: flex-end;
  z-index:100;
}
</style>